import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { NUMBER_ICONS, CIRCLE_ICONS, TILE_ICONS } from 'constants/icons';
import { CmsHeading } from 'components/CmsPage/modules/CmsHeading/CmsHeading';
import { CmsText } from 'components/CmsPage/modules/CmsText/CmsText';
import { NestDocumentLevel } from 'providers/DocumentLevel';

const ICON_POSITIONS = ['top', 'left', 'left-center'];
const ICON_SRC_BY_NAME = { ...NUMBER_ICONS, ...CIRCLE_ICONS, ...TILE_ICONS };

export const Tile = ({ description, icon, iconPosition, title }) => {
  const src = ICON_SRC_BY_NAME[icon];
  const tileClassName = classNames({
    Tile: true,
    [`Tile--position-${iconPosition}`]: ICON_POSITIONS.includes(iconPosition),
  });

  return (
    <NestDocumentLevel>
      <section className={tileClassName}>
        {src && <Isvg className="Tile__icon" src={src} />}
        <div className="Tile__content">
          <CmsHeading size="large" title={title} />
          <CmsText content={description} />
        </div>
      </section>
    </NestDocumentLevel>
  );
};

Tile.defaultProps = {
  iconPosition: 'top',
};

Tile.propTypes = {
  description: PropTypes.string,
  icon: PropTypes.oneOf(Object.keys(ICON_SRC_BY_NAME)),
  iconPosition: PropTypes.oneOf(ICON_POSITIONS),
  title: PropTypes.string,
};
